import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiResponse } from 'apisauce';

import { ReportStatusEnum } from '../../enums/report-status.enum';
import { processErrorInReducer } from '../helpers';

import { ReportType } from './types';

export interface ReportingFileState {
  file: string;
  isGettingFile: boolean;
  isGettingFileFailed: boolean;
  reportData: ReportType[];
  isGettingReport: ReportStatusEnum;
 }

export const INITIAL_STATE: ReportingFileState = {
  file: '',
  isGettingFile: false,
  isGettingFileFailed: false,
  reportData: [],
  isGettingReport: ReportStatusEnum.Ready,
};

const reportingFileSlice = createSlice({
  name: 'file',
  initialState: INITIAL_STATE,
  reducers: {
    getReportingFileByOrder(state: ReportingFileState, action: PayloadAction<string>) {
      state.isGettingFile = false;
      state.isGettingFileFailed = false;
    },
    getReportingFileByOrderSuccess(state: ReportingFileState, action) {
      state.isGettingFile = true;
      state.isGettingFileFailed = false;

      const { data } = action.payload;
      state.file = data;
    },
    getReportingFileByOrderFailed(state: ReportingFileState, action) {
      state.isGettingFile = true;
      state.isGettingFileFailed = true;
      processErrorInReducer(state, action);
    },
    getReport(state: ReportingFileState, action) {
      state.isGettingReport = ReportStatusEnum.Pending;
    },
    getReportSuccess(state: ReportingFileState, action) {
      const foundObjects = action.payload.filter((item: ApiResponse<ReportType>) => typeof item === 'object' && item !== null);
      state.reportData = foundObjects;
      state.isGettingReport = ReportStatusEnum.Ready;
    },
    getReportFailed(state: ReportingFileState, action) {
      state.isGettingReport = ReportStatusEnum.Error;
      processErrorInReducer(state, action);
    },
  },
  extraReducers: {},
});

export const {
  getReportingFileByOrder,
  getReportingFileByOrderSuccess,
  getReportingFileByOrderFailed,
  getReport,
  getReportSuccess,
  getReportFailed,
} = reportingFileSlice.actions;

export default reportingFileSlice.reducer;
